import http from './http';
import qs from 'qs';

// ====== Список товаров (по объекту params) ======
export async function fetchProducts(params = {}) {
  const { data } = await http.get('/api/products', { params });
  return data;
}

// ====== Список товаров (берёт параметры прямо из window.location.search) ======
// Удобно для каталога: не теряются ключи вида f[code], f[code].min/max и пр.
export async function fetchProductsFromSearch(params) {
  // A) строка "?a=1&b=2"
  if (typeof params === 'string') {
    const q = params && params[0] !== '?' ? `?${params}` : (params || '');
    const { data } = await http.get(`/api/products${q}`);
    return data;
  }
  // B) объект
  const { data } = await http.get('/api/products', { params });
  return data;
}

// товар по слагу
export async function fetchProductBySlug(slug) {
  const { data } = await http.get(`/api/products/slug/${slug}`);
  return data;
}

// алиас, если где-то используется
export async function getProductBySlug(slug) {
  return fetchProductBySlug(slug);
}

// товары по ids (корзина/сборка)
export async function fetchProductsByIds(ids = []) {
  if (!ids.length) return [];
  const { data } = await http.get('/api/products/by-ids', {
    params: { ids: ids.join(',') } // сервер понимает и массив, и CSV; так надёжнее
  });
  return data;
}

// distinct бренды из БД
export async function fetchBrands(params = {}) {
  // params: { topCategorySlug?, subcategoryId?, q? }
  const { data } = await http.get('/api/products/brands', { params });
  return data?.items || [];
}

export async function fetchFilterMeta(params = {}) {
  const { data } = await http.get('/api/products/filter-meta', { params });
  return data || { brands: [], colors: [], countries: [] };
}

export async function searchProducts(q, extra = {}) {
  return fetchProducts({ q, limit: 10, ...extra });
}

// если где-то нужно руками сериализовать параметры (оставляю, раз у тебя qs импортирован)
export function toQuery(params) {
  const q = qs.stringify(params, { encode: true, arrayFormat: 'repeat', indices: false });
  return q ? `?${q}` : '';
}
